<template>
  <div class="home content-continer">
    <!-- 最上面搜索 -->
    <div class="continer-top base-content">
      <el-row :gutter="0">
        <el-col :span="7">
          <div class="grid-content bg-purple">
            <span>医院名称</span>
            <input type="text" placeholder="请输入医院名称" v-model="hospitalName" />
          </div>
        </el-col>
        <el-col :span="7">
          <div class="grid-content bg-purple">
            <span>项目名称</span>
            <input type="text" placeholder="请输入项目名称" v-model="projectName" />
          </div>
        </el-col>
        <el-col :span="7">
          <div class="grid-content bg-purple">
            <span>项目状态</span>
            <el-select v-model="state" placeholder="请选择" style="width: auto;" class="ztinputs">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="3" style="text-align:right;">
          <div class="grid-content bg-purple">
            <el-button type="primary" icon="el-icon-search" @click="seachlist">搜索</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 下面数据 -->
    <div class="continer-title base-content">
      <div class="blue left" style="margin-top:-10px;">项目信息</div>
    </div>
    <!--项目列表  -->
    <div class="base-content item-list" v-for="(item,index) in projectlists" :key="item.id">
      <div>
        <a class="list-num">{{index+1}}</a>
        <a class="list-name">{{item.projectName}}</a>
        <a class="w-status" v-if="item.delegationState=='1'">
          <img src="../assets/hospital-img/no-w.png" />
        </a>
        <a class="w-status" v-if="item.delegationState=='2'">
          <img src="../assets/hospital-img/s-no-j.png" />
        </a>
        <a class="w-status" v-if="item.delegationState=='3'">
          <img src="../assets/hospital-img/s-y-j.png" />
        </a>
        <a class="w-status" v-if="item.delegationState=='4'">
          <img src="../assets/hospital-img/yes-wc.png" />
        </a>
      </div>
      <ul class="list-msg">
        <li>
          <p>专业名称</p>
          <p>{{item.specialityName?item.specialityName:'无'}}</p>
        </li>
        <li>
          <p>CRC人数</p>
          <p>{{item.crcNum?item.crcNum:'无'}}</p>
        </li>
        <li>
          <p>项目类型</p>
          <p>{{item.phaseDesc?item.phaseDesc:'无'}}</p>
        </li>
        <li>
          <p>项目开始时间</p>
          <p>{{item.startDate}}</p>
        </li>
        <li>
          <p>申办方</p>
          <p v-if="item.sponsorName!=''&&item.sponsorName.length>=15">
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.sponsorName"
              placement="top-start"
            >
              <el-button>{{item.sponsorName}}</el-button>
            </el-tooltip>
          </p>
          <p v-if="item.sponsorName.length<=15">{{item.sponsorName}}</p>
          <p v-if="item.sponsorName==''">无</p>
        </li>
        <li>
          <p>医院名称</p>
          <p v-if="item.hospitalName==''">无</p>
          <p v-if="item.hospitalName.length<=12">{{item.hospitalName}}</p>
          <el-tooltip
            class="item"
            effect="dark"
            :content="item.hospitalName"
            placement="top-start"
            v-if="item.hospitalName!=''&&item.hospitalName.length>=13"
          >
            <el-button>{{item.hospitalName}}</el-button>
          </el-tooltip>
        </li>

        <li v-if="item.delegationState==1">
          <router-link :to="`/CIndex/company-appoint/`+item.id">CRC委派</router-link>
          <router-link
            :to="`/CIndex/wait-reception/`+item.id"
            style="margin-left:5px;"
            v-if="item.isDelegate=='1'"
          >查看</router-link>
        </li>
        <li v-if="item.delegationState==2">
          <router-link :to="`/CIndex/wait-reception/`+item.id">查看</router-link>
        </li>
        <li v-if="item.delegationState=='3'">
          <router-link :to="`/CIndex/wait-reception/`+item.id">查看</router-link>
        </li>
        <li v-if="item.delegationState=='4'">
          <router-link :to="`/CIndex/wait-reception/`+item.id">查看</router-link>
        </li>
      </ul>
    </div>
    <div class="center" style="margin-bottom: 100px;" v-if="total">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="projectlist"
      ></el-pagination>
    </div>
    <div class="center" style="margin-top: 100px;" v-if="total==''">暂无数据</div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { Cprojectslist } from "@/request/api";
export default {
  name: "home",
  data() {
    return {
      newbuit: false,
      options: [
        {
          value: "1",
          label: "待委派"
        },
        {
          value: "2",
          label: "待接收"
        },
        {
          value: "3",
          label: "已接收"
        },
        {
          value: "4",
          label: "已完成"
        },
        {
          value: "",
          label: "全部"
        }
      ],
      value: "",
      userId: "",
      pageIndex: 1,
      projectName: "",
      hospitalName: "",
      state: "",
      total: "",
      projectlists: "",
      userId: "13"
    };
  },
  methods: {
    check(n) {
      if (n == "" || n == null || n == undefined) {
        n = "无";
      }
    },
    buitxm() {
      this.newbuit = true;
    },
    seachlist() {
      this.projectlist();
    },
    // 获取项目列表
    projectlist(event) {
      this.pageIndex = event;
      let projectseach = {
        pageIndex: this.pageIndex,
        pageSize: "5",
        projectName: this.projectName,
        hospitalName: this.hospitalName,
        state: this.state,
        userId: Cookies.get("userid")
      };
      Cprojectslist(projectseach)
        .then(res => {
          console.log(res.data.data);
          let pagedata = res.data.data;
          this.total = pagedata.total;
          this.projectlists = pagedata.list;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.projectlist();
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.newbuit-content .el-row {
  margin-bottom: 20px;
}

.el-input__prefix {
  left: 15px;
}

.el-textarea {
  width: auto;
}

.el-textarea textarea {
  width: 926px;
  margin-left: 10px;
  min-height: 40px !important;
  border-radius: 2px;
  border-collapse: #ccc;
  display: inline-block;
}

.item-list {
  position: relative;
}

.list-msg {
  margin-top: 30px;
}

.list-msg li {
  display: inline-block;
  margin-right: 30px;
  font-size: 14px;
}

.list-msg li:last-child {
  margin-right: 0px;
}

.list-msg li p:first-child {
  color: #999999;
}

.list-msg li p:last-child {
  color: #666666;
  margin-top: 8px;
}

.w-status {
  position: absolute;
  right: 0px;
  top: 0px;
}

.list-msg li:first-child {
  width: 120px;
}

.list-msg li:nth-child(2) {
  width: 60px;
}

.list-msg li:nth-child(3) {
  width: 60px;
}

.list-msg li:nth-child(4) {
  width: 92px;
}

.list-msg li:nth-child(5) {
  width: 200px;
}

.list-msg li:nth-child(6) {
  width: 200px;
}

.el-textarea {
  margin-left: 10px !important;

  width: 900px;
}

.continer-top input,
.newbuit-content input {
  width: 180px !important;
}
.item-list >>> .el-button {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: none;
  height: auto;
  padding: 0px;
  text-align: left;
}
.item-list >>> .el-button:hover {
  background: #fff;
  color: #666;
}
.ztinputs >>> input {
  width: 180px;
}
</style>


// WEBPACK FOOTER //
// src/company/home.vue